import {
    Dimensions,
    I18nManager,
    Platform,
    View,
} from "react-native";

import { Transparent, White } from "react-native-material-color";
import * as Constants from "./Constants";
import { border } from "./Styles";


// const drawerIconImg = require('../images/drawer_icon.png');

export const isLtr = () => !I18nManager.isRTL;
const isMobile = Dimensions.get("window").width < Constants.MIN_WIDTH;

// Helper function to get proper font family for React Native based on weight
export const getSatoshiFont = (weight = 400) => {
    // if (Platform.OS === 'web') {
    //     return "Satoshi";
    // }

    switch (weight) {
        case 500:
        case "500":
        case "medium":
            return "Satoshi-Medium";
        case 700:
        case "700":
        case "bold":
            return "Satoshi-Bold";
        case 400:
        case "400":
        case "normal":
        default:
            return "Satoshi-Regular";
    }
};

// Helper function to convert percentage lineHeight to numeric values
export const getLineHeight = (fontSize, percentage) => {
    if (Platform.OS === 'web') {
        return `${percentage}%`;
    }
    return Math.round(fontSize * (parseFloat(percentage) / 100));
};

// Helper function to get proper fontWeight
export const getFontWeight = (weight) => {
    if (Platform.OS === 'web') {
        return weight;
    }
    if (weight >= 700) return 'bold';
    if (weight >= 500) return '500';
    return 'normal';
};

export const renderSeparator = (w) => <View style={{ width: w }} />;
export const renderVSeparator = (h) => <View style={{ height: h }} />;
export const fontFamily = getSatoshiFont(400);
export const appColor1 = "#3B627F";
export const appColor2 = "#3B627F";
export const appColor3 = '#808080';
export const appColor4 = Transparent;
export const appColor5 = 'rgba(59, 98, 127, 0.50)';
export const hoverColor = '#52C0EE';
export const H1FontSize = isMobile ? 28 : 28;
export const H2FontSize = isMobile ? 22 : 22;
export const H3FontSize = isMobile ? 18 : 18;
export const BodyText = isMobile ? 16 : 16;
export const SecondaryText = isMobile ? 12 : 12;
export const ButtonText = isMobile ? 16 : 16;
export const LabelText = isMobile ? 12 : 12;
export const appTextTitle = 20;
export const desktopBackgroundColor = '#f9fdfe'

export const otherTabTitle = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 18,
    fontWeight: Platform.OS === 'web' ? 400 : 'normal',
    lineHeight: 18 * 1.4,
};

export const showFilterText = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 14,
    letterSpacing: -0.07,
};

export const productLenText = {
    color: 'rgba(59, 98, 127, 0.38)',
    fontFamily: getSatoshiFont(400),
    fontSize: 14,
    lineHeight: 14 * 1.35,
    letterSpacing: -0.07,
};

export const cartBonusText = {
    color: '#FFF',
    textAlign: 'center',
    fontFamily: getSatoshiFont(700),
    fontSize: 9.6,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 700 : 'bold',
    lineHeight: 9.6 * 1.2,
};

export const noBonusStyle = {
    width: 78,
    height: 31,
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'flex-start',
    position: isMobile ? 'absolute' : undefined,
    // bottom: 38,
    zIndex: isMobile ? 2 : undefined,
};

export const wBonusStyle = {
    width: 78,
    height: 31,
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'flex-start',
    position: 'absolute',
    top: 18,
    zIndex: 3
};

export const notificationText = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 18,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 400 : 'normal',
    lineHeight: 18 * 1.4,
};

export const notificationTextTitles = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 400 : 'normal',
    lineHeight: 16 * 1.6,
};

export const notificationTextCheckBox = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 15,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 700 : 'bold',
    lineHeight: 15 * 1.4,
};

export const mainNotificationText = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 700 : 'bold',
    lineHeight: 16 * 1.4,
};

export const mainNotificationDescText = {
    color: 'rgba(20, 36, 46, 0.62)',
    fontFamily: getSatoshiFont(400),
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 400 : 'normal',
    lineHeight: 14 * 1.4,
};

export const orderSummarySubTotalText = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 500 : 'normal',
    // lineHeight: 16 * 1.5,
    letterSpacing: 0.48,
}

export const orderSummarySubTotalAmount = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 500 : 'normal',
    // lineHeight: 16 * 2.0,
    letterSpacing: 0.48,
}

export const checkOutPaymentTerms = {
    color: 'rgba(59, 98, 127, 0.50)',
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 400 : 'normal',
    lineHeight: 16 * 1.6,
    letterSpacing: 0.08,
};

export const orderSummaryDiscount = {
    color: '#545454',
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 400 : 'normal',
    lineHeight: 16 * 2.0,
}

export const checkOutPaymentTermsBold = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 700 : 'bold',
    lineHeight: 16 * 1.6,
    marginTop: 6,
    letterSpacing: 0.08,
};

export const checkOutExpectedDate = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 400 : 'normal',
    lineHeight: 16 * 1.6,
    letterSpacing: 0.08,
};

export const checkOutExpectDateDesktop = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 400 : 'normal',
    lineHeight: 16 * 2.0,
    letterSpacing: 0.48,
}

export const checkOutDelevery = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 20,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 400 : 'normal',
    lineHeight: 20, // "normal" becomes just fontSize
    letterSpacing: -0.4,
};

export const checkOutDelvDesktop = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 500 : 'normal',
    lineHeight: 16 * 1.5,
    letterSpacing: 0.48,
}

export const checkOutMiniDescStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 500 : 'normal',
    lineHeight: 13.6,
    width: Dimensions.get("window").width - 255,
    textTransform: 'capitalize'
};
export const checkOutDescStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 500 : 'normal',
    lineHeight: 16 * 1.5,
};

export const desktopBonusItems = {
    color: '#fff',
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 500 : 'normal',
    lineHeight: 16 * 1.0,
};

export const pricePerItem = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: Platform.OS === 'web' ? 400 : 'normal',
    lineHeight: 14 * 1.714,
};

export const desktopCartName = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 20,
    fontStyle: "normal",
    lineHeight: getLineHeight(20, 140),
}

export const activeOrdersText = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 18,
    fontStyle: "normal",
    lineHeight: getLineHeight(18, 140),
}

export const checkOutPriceMiniStyle = {
    color: 'rgba(33, 33, 33, 0.50)',
    fontFamily: getSatoshiFont(500),
    fontSize: 10,
    fontStyle: "normal",
    paddingVertical: 2,
};

export const cartTextItems = {
    color: appColor1,
    fontFaily: getSatoshiFont(700),
    fontSize: 20,
    lineHeight: 20,
};

export const clearCheckOut = {
    color: '#9197B3',
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 150),
};

export const checkOutPriceStyle = {
    // color: 'rgba(33, 33, 33, 0.50)',
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 14,
    fontStyle: "normal",
    lineHeight: getLineHeight(14, 171.429),
    paddingVertical: 2,
};

export const checekOutPriceStyleDesktop = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 200),
    letterSpacing: 0.48,
}

export const expiryDate = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
};

export const secondPriceAmount = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: 1.2 * 16,
};

export const secondPriceJODText = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
    // lineHeight: .5 * 16,
};

export const brandName = {
    color: appColor1,
    textAlign: 'center',
    fontFamily: getSatoshiFont(400),
    fontSize: 14,
    fontStyle: "normal",
    lineHeight: getLineHeight(14, 114.881),

}

export const productDetailsTitle = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 30,
    fontStyle: "normal",
}

export const orderListText = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 160),
};

export const bonusBoxText = {
    color: '#FFF',
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 160),

};

export const searchedText = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 14,
    lineHeight: getLineHeight(14, 135),
    letterSpacing: -0.7,
};

export const giftText = {
    color: '#6BA461',
    fontFamily: getSatoshiFont(700),
    fontSize: 13,
};

export const giftTextDesktop = {
    color: '#6BA461',
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    lineHeight: getLineHeight(16, 100),

}

export const bonusSearchText = {
    color: '#FFF',
    textAlign: 'center',
    fontFamily: getSatoshiFont(700),
    fontSize: 7.5,

    lineHeight: getLineHeight(7.5, 120),
};

export const bonusSearchTextx = {
    color: '#FFF',
    textAlign: 'center',
    fontFamily: getSatoshiFont(500),
    fontSize: 12,

    lineHeight: getLineHeight(12, 120),
};

export const BonusText = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 120),
};

export const priceAmountStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 25,
    fontStyle: "normal",
    lineHeight: getLineHeight(25, 120),
};

export const priceJODTextStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 120),
};

export const filtersNamesStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 160),
};

export const orderNowBrandNameStyle = {
    color: '#52C0EE',
    fontFamily: getSatoshiFont(700),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 120),
};

export const filtersTitlesStyle = {
    fontFamily: getSatoshiFont(700),
    fontSize: 16,
    color: appColor1,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 160),
};

export const filtersHeaderStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 140),
};

export const checkOutCart = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 24,
    fontStyle: "normal",
    lineHeight: getLineHeight(24, 100),
};

export const checkOutCartText = {
    fontFamily: getSatoshiFont(400),
    fontSize: 18,
    fontStyle: "normal",
    lineHeight: getLineHeight(18, 140),
    color: appColor1,
}
export const appliedFiltersStyle = {
    color: '#6BA461',
    fontFamily: getSatoshiFont(700),
    fontSize: 12,
    fontStyle: "normal",
    lineHeight: getLineHeight(12, 140),
};

export const OrderNowDescStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 15,
    fontStyle: "normal",
    lineHeight: getLineHeight(15, 135),
    minHeight: 35,
    textTransform: 'capitalize',
};

export const orderNowPriceStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 14,
    fontStyle: "normal",
};

export const featruredItemsPrice = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 14,
    fontStyle: "normal",
}

export const featuredItemsQtyStyle = {
    color: 'white',
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 135),
    minHeight: getLineHeight(16, 135),
    textAlignVertical: 'center',
};

export const InvoiceButton = {
    alignItems: 'center',
    gap: 8,
    flexDirection: 'row',
    borderRadius: 8,
    backgroundColor: appColor1,
    padding: 14,
    justifyContent: isMobile ? "center" : "center",
};

export const InvoiceButtonText = {
    color: '#fff',
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 125),
};

export const featuredItemsCheckout = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 16,
    lineHeight: getLineHeight(16, 135),
    minHeight: getLineHeight(16, 135),
    textAlignVertical: 'center',
}


export const featuredItemsQtyMiniStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(500),
    fontSize: 12,
    fontStyle: "normal",
    lineHeight: 16,
    minHeight: 16,
    textAlignVertical: 'center',
};

export const featuredItemsPriceStyle = {
    fontFamily: getSatoshiFont(400),
    fontSize: 13,
    fontStyle: "normal",
    color: 'rgba(33, 33, 33, 0.50)',
};

export const featuredItemsTextStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 15,
    fontStyle: "normal",
    lineHeight: getLineHeight(15, 135),
};

export const orderNowTextStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 16,
    lineHeight: getLineHeight(16, 160),
};

export const categoriesText = {
    fontFamily: getSatoshiFont(400),
    color: appColor2,
    fontSize: 14,
    fontStyle: "normal",
    lineHeight: getLineHeight(14, 120),
};

export const offersSecondText = {
    fontFamily: getSatoshiFont(700),
    fontSize: 17,
    fontStyle: "normal",
    lineHeight: getLineHeight(17, 130),
    color: '#D70202',
};

export const offersFirstText = {
    fontFamily: getSatoshiFont(400),
    fontSize: 13,
    fontStyle: "normal",
    color: 'rgba(59, 98, 127, 0.50)',
};

export const appFeaturedTextStyle = {
    fontFamily: getSatoshiFont(700),
    fontSize: 15,
    color: appColor1,
    lineHeight: getLineHeight(15, 135),
};

export const appFooterTextStyle = {
    fontFamily: getSatoshiFont(400),
    fontSize: 11,
    color: appColor1,
    marginTop: 4,
    lineHeight: getLineHeight(11, 135),
    textAlign: "center",
}

export const categTextStyle = {
    fontFamily: getSatoshiFont(400),
    fontSize: 10.382,
    fontStyle: "normal",
    color: appColor1,
}

export const appTitleStyle = {
    fontFamily: getSatoshiFont(700),
    fontSize: appTextTitle,
    color: appColor1,
    letterSpacing: -0.4,
};

export const H1Styles = {
    fontFamily: getSatoshiFont(500),
    fontSize: H1FontSize,
    color: appColor1,
    lineHeight: getLineHeight(H1FontSize, 120),
};

export const H2Styles = {
    fontFamily: getSatoshiFont(700),
    fontSize: H2FontSize,
    color: appColor1,
    lineHeight: getLineHeight(H2FontSize, 140),
};

export const H3Styles = {
    fontFamily: getSatoshiFont(400),
    fontSize: H3FontSize,
    color: appColor1,
    lineHeight: getLineHeight(H3FontSize, 140),
};

export const tblHeaderStyle = {
    fontFamily: getSatoshiFont(700),
    fontSize: H3FontSize,
    color: appColor3,
    color: appColor1,
    marginTop: 10
};

export const BodyTextStyles = {
    fontFamily: getSatoshiFont(400),
    fontSize: BodyText,
    color: appColor1,
    lineHeight: getLineHeight(BodyText, 160),
};

export const orderDateDetails = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 150),
};

export const estimatedDelv = {
    color: '#6BA461',
    fontFamily: getSatoshiFont(700),
    fontSize: 16,
    fontStyle: "normal",
    lineHeight: getLineHeight(16, 150),
};

export const BodyTextInvDetailsStyles = {
    fontFamily: getSatoshiFont(400),
    fontSize: BodyText,
    color: '#6D777E',
    lineHeight: getLineHeight(BodyText, 160),
}

export const BodyTextHoveredStyle = {
    fontFamily: getSatoshiFont(400),
    fontSize: BodyText,
    color: '#52C0EE',
    lineHeight: getLineHeight(BodyText, 160),
}

export const SecondaryTextStyles = {
    fontFamily: getSatoshiFont(400),
    fontSize: SecondaryText,
    color: appColor1,
    lineHeight: getLineHeight(SecondaryText, 140),
};

export const ButtonTextStyles = {
    fontFamily: getSatoshiFont(700),
    fontSize: ButtonText,
    color: appColor1,
    lineHeight: getLineHeight(ButtonText, 120),
};

export const LabelTextStyles = {
    fontFamily: getSatoshiFont(500),
    fontSize: LabelText,
    color: appColor1,
    lineHeight: getLineHeight(LabelText, 140),
};


export const OtpTextStyles = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 32,
    lineHeight: getLineHeight(32, 160),
};

export const TextInputStyles1 = {
    padding: 13.5,
    alignItems: isMobile ? "center" : undefined,
    gap: isMobile ? 8 : undefined,
    borderRadius: 16,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    color: 'rgba(59, 98, 127, 0.50)',
    fontFamily: getSatoshiFont(400),
    fontSize: BodyText,
    lineHeight: getLineHeight(BodyText, 160),
    alignSelf: isMobile ? "stretch" : undefined,
};

export const TextInputStyles1x = {

    padding: 13.5,
    alignItems: isMobile ? "center" : undefined,
    gap: isMobile ? 8 : undefined,
    borderRadius: 16,
    backgroundColor: '#fff',
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: BodyText,
    lineHeight: getLineHeight(BodyText, 160),
    alignSelf: isMobile ? "stretch" : undefined,
};

export const TextInputStyles1Secondary = {
    padding: 13.5,
    alignItems: isMobile ? "center" : 'center',
    gap: isMobile ? 8 : 8,
    borderRadius: 16,
    backgroundColor: '#0000000a',
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: BodyText,
    lineHeight: getLineHeight(BodyText, 160),
    alignSelf: isMobile ? "stretch" : "stretch",
};

export const TextInputStyles2 = {

    padding: 13.5,
    alignItems: isMobile ? "center" : undefined,
    gap: isMobile ? 8 : undefined,
    borderRadius: 16,
    backgroundColor: '#3b627f26',
};

export const TextInputStyles3 = {

    padding: 13.5,
    alignItems: isMobile ? "center" : undefined,
    gap: isMobile ? 8 : undefined,
    borderRadius: 16,
    backgroundColor: '#3b627f26',
};

export const TextInputStyles4 = {
    padding: 13.5,
    alignItems: isMobile ? "center" : "center",
    gap: isMobile ? 8 : 8,
    borderRadius: 16,
    backgroundColor: 'linear-gradient(0deg, rgba(215, 2, 2, 0.20) 0%, rgba(215, 2, 2, 0.20) 100%), #DEE3E6',
    color: '#3b627f80',
    alignSelf: isMobile ? "stretch" : "stretch",
    lineHeight: getLineHeight(BodyText, 160),
    fontSize: BodyText,
    fontFamily: getSatoshiFont(400),
};

export const accountHoldHeader = {
    fontFamily: getSatoshiFont(400),
    fontSize: 22,
    lineHeight: getLineHeight(22, 140),
    fontStyle: "normal",
    color: appColor1,
};

export const accountHoldText = {
    fontFamily: getSatoshiFont(400),
    fontSize: 12,
    fontStyle: "normal",
    lineHeight: getLineHeight(12, 140),
    color: appColor1,
};

export const loginButtonStyles = {

    height: 48,
    padding: 14,
    justifyContent: isMobile ? "center" : "center",
    alignItems: isMobile ? "center" : "center",
    alignSelf: isMobile ? "stretch" : "stretch",
    gap: isMobile ? 8 : 8,
    borderRadius: 20,
    backgroundColor: appColor1,
};

export const primaryButtonStyle = {
    flexDirection: 'row',
    height: 41,
    paddingHorizontal: 16,
    paddingVertical: 10,
    justifyContent: isMobile ? "center" : "center",
    alignItems: isMobile ? "center" : "center",
    alignSelf: isMobile ? "stretch" : "stretch",
    gap: 8,
    borderRadius: 8,
    backgroundColor: appColor1,
};
export const secondaryButtonStyle = {

    height: 41,
    paddingHorizontal: 16,
    paddingVertical: 10,
    justifyContent: isMobile ? "center" : "center",
    alignItems: isMobile ? "center" : "center",
    alignSelf: isMobile ? "stretch" : "stretch",
    gap: 8,
    borderRadius: 8,
    backgroundColor: hoverColor,
};

export const placeOrderButtonDesktop = {
    padding: 16,
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: 6,
    backgroundColor: appColor1,
}

export const loginButtonTextStyles = {
    fontFamily: getSatoshiFont(400),
    fontSize: ButtonText,
    color: White,
    lineHeight: getLineHeight(ButtonText, 120),
};

export const AcitvateButtonStyles = {

    height: 48,
    padding: 14,
    justifyContent: isMobile ? "center" : "center",
    alignItems: isMobile ? "center" : "center",
    alignSelf: isMobile ? "stretch" : "stretch",
    gap: isMobile ? 8 : 8,
    borderRadius: 20,
    backgroundColor: '#D7D7D7',
};

export const AcitvateButtonTextStyles = {
    fontFamily: getSatoshiFont(700),
    fontSize: ButtonText,
    color: appColor1,
    lineHeight: getLineHeight(ButtonText, 120),
};

export const secondaryButtonStyles = {

    height: 48,
    padding: 14,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    gap: 8,
    borderRadius: 20,
    backgroundColor: '#AFAFAF',
};

export const secondaryButtonStyleOpacity = {

    height: 48,
    padding: 14,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    gap: 8,
    borderRadius: 20,
    backgroundColor: appColor1,
    opacity: 0.4,
};

export const OtpCodeInput = {

    width: 56,
    height: 64,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    borderRadius: 16,
    backgroundColor: '#DEE3E6',
    textAlign: 'center',
};

export const OtpCodeInput2 = {

    width: 56,
    height: 64,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    borderRadius: 16,
    backgroundColor: 'linear-gradient(0deg, rgba(0, 0, 0, 0.10) 0%, rgba(0, 0, 0, 0.10) 100%), #DEE3E6',
    textAlign: 'center',
};

export const OtpCodeInput3 = {

    width: 56,
    height: 64,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    borderRadius: 16,
    backgroundColor: '#AFAFAF',
    color: appColor1,
    fontSize: 32,
    textAlign: 'center',
    opacity: 0.9,
};

export const OtpCodeInput4 = {

    width: 56,
    height: 64,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    borderRadius: 16,
    backgroundColor: 'linear-gradient(0deg, rgba(215, 2, 2, 0.20) 0%, rgba(215, 2, 2, 0.20) 100%), #DEE3E6',
    color: appColor1,
    fontSize: 32,
    textAlign: 'center',
};

export const OtpViewStyle = {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
    marginTop: 8
};

export const DueBalanceNumStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 32,
    letterSpacing: -0.64,
};

export const DueBalanceTextStyle = {
    color: 'rgba(59, 98, 127, 0.70)',
    fontFamily: getSatoshiFont(700),
    fontSize: 14,
    letterSpacing: -0.28,
    flex: 1,
};

export const MyOrdersStyle = {
    display: 'flex',
    minWidth: 160,
    paddingHorizontal: 16,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: "flex-start",
    // flex:1,
    borderRadius: 12,
    backgroundColor: '#FFF',
    boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.08)',
};

export const cardStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderRadius: 12,
    backgroundColor: '#FFF',
    boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.08)',
    width: '48%',
    height: 155,
    paddingHorizontal: 16,
};

export const orderShopStatus = {
    color: appColor2,
    fontFamily: getSatoshiFont(400),
    fontSize: 12,
    maxWidth: 60,
    lineHeight: getLineHeight(12, 140),
}

export const cancelText = {
    color: '#D70202',
    fontFamily: getSatoshiFont(400),
    fontSize: 12,

    lineHeight: getLineHeight(12, 140),
};

export const productDetailsSpecText = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 12,
    lineHeight: getLineHeight(12, 140),
};


export const checkoutNotesStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(400),
    fontSize: 12,
    lineHeight: getLineHeight(12, 140),
};

export const AllOrdersStyle = {
    display: 'flex',
    paddingHorizontal: 20,
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: 10,
    borderWidth: 1,
    backgroundColor: '#FFF',
    borderColor: '#FFF',
    flexDirection: 'row',
    boxShadow: '15px 15px 15px 0 rgba(32, 32, 32, 0.03)'
};

export const orderActiveStyle = {
    // paddingHorizontal: 20,
    // justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: 10,
    borderWidth: 1,
    backgroundColor: '#fff',
    // flexDirection: 'row',
}

export const AccountStatementStyle = {
    display: 'flex',
    paddingHorizontal: 16,
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    alignSelf: 'stretch',
    borderRadius: 4,
    backgroundColor: '#FFF',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.08)',
};

export const TotalDebitCreditStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 14.5,
    paddingHorizontal: 16,
    // flex:1,
    borderRadius: 16,
    backgroundColor: 'linear-gradient(0deg, rgba(59, 98, 127, 0.04) 0%, rgba(59, 98, 127, 0.04) 100%), #FFF',
};

export const TransactionsStyle = {
    display: 'flex',
    paddingHorizontal: 20,
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: 10,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    flexDirection: 'row',
};

export const JODinvoiceStyle = {
    color: 'rgba(59, 98, 127, 0.50)',
    fontFamily: getSatoshiFont(700),
    fontSize: 11,
    lineHeight: getLineHeight(11, 160),
};

export const CheckoutQtyErrorStyle = {
    color: hoverColor,
    fontFamily: getSatoshiFont(400),
    fontSize: 11,
};

export const CheckoutNORetStyle = {
    color: '#FF1B00',
    fontFamily: getSatoshiFont(500),
    fontSize: 11,
};

export const InvoiceDetailsMainViewStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 16,
    alignSelf: 'stretch',
    borderBottomWidth: 1,
    borderBottomColor: '1px solid rgba(59, 98, 127, 0.10)',
    flex: 1
};

export const InvoiceDetailsItemsStyle = {
    color: appColor1,
    fontFamily: getSatoshiFont(700),
    fontSize: 14.225,

    lineHeight: getLineHeight(14, 135),
};

export const InvoiceDetailsItemsStyle2 = {
    color: 'red',
    fontFamily: getSatoshiFont(700),
    fontSize: 14.225,

    lineHeight: getLineHeight(14, 135),
};

export const ButtonBeforePress = {
    borderRadius: 14,
    width: '50%',
    textAlign: 'center',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
};

export const ButtonAfterPress = {
    borderRadius: 14,
    backgroundColor: '#FFF',
    width: '50%',
    textAlign: 'center',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: ' 0px 1px var(--shadow-shadow-blur-tiny, 4px) 0px var(--shadow-shadow-tiny-small-large, rgba(0, 0, 0, 0.08))',
    height: 36,
    // marginHorizontal: 2,
};

export const ordersMainViewStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    // borderRadius: 10,
    // backgroundColor: 'rgba(217, 217, 217, 0.10)',
    flexDirection: 'row',
};

export const UpdatingAccountStyle = {
    color: appColor1,
    textAlign: 'center',
    fontFamily: getSatoshiFont(400),
    fontSize: 12,
    lineHeight: getLineHeight(12, 140),
};

export const dateTextStyle = {
    color: 'rgba(59, 98, 127, 0.50)',
    textAlign: 'center',
    fontFamily: getSatoshiFont(700),
    fontSize: 17,

    lineHeight: getLineHeight(17, 135),
};

export const FromToDateTextStyle = {
    color: 'rgba(59, 98, 127, 0.50)',
    textAlign: 'center',
    fontFamily: getSatoshiFont(700),
    fontSize: 12,
    lineHeight: getLineHeight(12, 135),
};

export const dateTextStyle2 = {
    color: appColor1,
    textAlign: 'center',
    fontFamily: getSatoshiFont(700),
    fontSize: 17,

    lineHeight: getLineHeight(17, 135),
};

export const ProfileImageStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 360,
    // backgroundColor: '#FFF',
    width: 88.866,
    height: 88.866,
};
